import { defineComponent } from 'vue';
import Illustration from '../molecules/Illustration.vue';
import TitleAndDescription from '../molecules/TitleAndDescription.vue';
import Actions from '../molecules/Actions.vue';
export default defineComponent({
    name: 'EmptyState',
    compatConfig: {
        MODE: 3,
    },
    components: {
        Actions,
        TitleAndDescription,
        Illustration,
    },
    props: {
        emptyState: {
            type: Object,
            required: true,
        },
    },
    emits: ['click'],
});
